export default "__VITE_ASSET__3959a1b4__"